import CityPage from '../../components/CityPage';

const cityData = {
    name: "Saint-Arnoult",
    slug: "saint-arnoult",
    postalCode: "14800",
    intro: "CC Débarras 14 intervient à Saint-Arnoult pour tous vos besoins de débarras. Nichée entre Deauville et Tourgéville, la commune de Saint-Arnoult fait partie de notre zone d'intervention privilégiée. Maisons, villas, dépendances : nous prenons en charge l'intégralité du débarras, de la première visite au dernier carton. Service gratuit si les objets sont revendables, devis sans engagement sinon.",
    nearby: ["Deauville", "Tourgéville", "Blonville-sur-Mer", "Bénerville-sur-Mer", "Touques"],
};

const SaintArnoult = () => <CityPage city={cityData} />;

export default SaintArnoult;
